(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pof-about-approach"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var root = document.querySelector('[data-pof-approach]');
    if (!root) return;
    var modal = root.querySelector('[data-pof-approach-modal]');
    if (!modal) return;
    var panes = Array.prototype.slice.call(modal.querySelectorAll('[data-pof-approach-pane]'));
    var dots = modal.querySelectorAll('[data-pof-approach-goto]');
    var total = panes.length;
    var current = 0;
    function show(i){
      i = ((i % total) + total) % total;
      current = i;
      panes.forEach(function(p, idx){ p.hidden = (idx !== i); });
      dots.forEach(function(d, idx){ d.classList.toggle('pofabout__approach-modal-dot--active', idx === i); });
    }
    function open(i){ modal.hidden = false; document.body.style.overflow='hidden'; show(parseInt(i,10)||0); }
    function close(){ modal.hidden = true; document.body.style.overflow=''; }
    root.addEventListener('click', function(e){
      var o = e.target.closest('[data-pof-approach-open]');
      if (o) { open(o.getAttribute('data-pof-approach-open')); return; }
      if (e.target.closest('[data-pof-approach-close]')) { close(); return; }
      if (e.target.closest('[data-pof-approach-prev]')) { show(current - 1); return; }
      if (e.target.closest('[data-pof-approach-next]')) { show(current + 1); return; }
      var dot = e.target.closest('[data-pof-approach-goto]');
      if (dot) { show(parseInt(dot.getAttribute('data-pof-approach-goto'), 10)); }
    });
    document.addEventListener('keydown', function(e){
      if (modal.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') show(current + 1);
      else if (e.key === 'ArrowLeft') show(current - 1);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pof-about-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var scrollIndicator = document.querySelector('.pofabout__hero [data-pof-scroll-indicator]');
  if (!scrollIndicator) return;
  var lastHidden = null;
  window.addEventListener('scroll', function () {
    var shouldHide = window.scrollY > 50;
    if (shouldHide !== lastHidden) {
      scrollIndicator.classList.toggle('is-hidden', shouldHide);
      lastHidden = shouldHide;
    }
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pof-about-stats"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var root = document.querySelector('[data-pof-statmodal]');
    if (!root) return;
    var modal = root.querySelector('[data-pof-stat-modal]');
    if (!modal) return;
    var panes = Array.prototype.slice.call(modal.querySelectorAll('[data-pof-stat-pane]'));
    var dots = modal.querySelectorAll('[data-pof-stat-goto]');
    var total = panes.length;
    var current = 0;

    function animateBars(pane){
      var bars = pane.querySelectorAll('[data-pof-bar-target]');
      bars.forEach(function(b){ b.style.height = '0%'; });
      requestAnimationFrame(function(){
        requestAnimationFrame(function(){
          bars.forEach(function(b){ b.style.height = b.getAttribute('data-pof-bar-target') + '%'; });
        });
      });
    }
    function show(i){
      i = ((i % total) + total) % total;
      current = i;
      panes.forEach(function(p, idx){ p.hidden = (idx !== i); });
      dots.forEach(function(d, idx){ d.classList.toggle('pofabout__stat-modal-dot--active', idx === i); });
      animateBars(panes[i]);
    }
    function open(i){ modal.hidden = false; document.body.style.overflow='hidden'; show(parseInt(i,10)||0); }
    function close(){ modal.hidden = true; document.body.style.overflow=''; }
    root.addEventListener('click', function(e){
      var o = e.target.closest('[data-pof-stat-open]');
      if (o) { open(o.getAttribute('data-pof-stat-open')); return; }
      if (e.target.closest('[data-pof-stat-close]')) { close(); return; }
      if (e.target.closest('[data-pof-stat-prev]')) { show(current - 1); return; }
      if (e.target.closest('[data-pof-stat-next]')) { show(current + 1); return; }
      var dot = e.target.closest('[data-pof-stat-goto]');
      if (dot) { show(parseInt(dot.getAttribute('data-pof-stat-goto'), 10)); }
    });
    document.addEventListener('keydown', function(e){
      if (modal.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') show(current + 1);
      else if (e.key === 'ArrowLeft') show(current - 1);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pof-about-values"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var root = document.querySelector('[data-pof-values]');
    if (!root) return;
    var modal = root.querySelector('[data-pof-value-modal]');
    if (!modal) return;
    var panes = Array.prototype.slice.call(modal.querySelectorAll('[data-pof-value-pane]'));
    var dots = modal.querySelectorAll('[data-pof-value-goto]');
    var total = panes.length;
    var current = 0;

    function animateCharts(pane){
      // Reset bars to 0 height, then animate up
      var bars = pane.querySelectorAll('[data-pof-bar-target]');
      bars.forEach(function(b){ b.style.height = '0%'; });
      // Reset radials to 0 dash, then animate
      var radials = pane.querySelectorAll('[data-pof-radial-target]');
      radials.forEach(function(r){ r.setAttribute('stroke-dasharray', '0 251'); });
      requestAnimationFrame(function(){
        requestAnimationFrame(function(){
          bars.forEach(function(b){ b.style.height = b.getAttribute('data-pof-bar-target') + '%'; });
          radials.forEach(function(r){ var t = parseFloat(r.getAttribute('data-pof-radial-target')) || 0; r.setAttribute('stroke-dasharray', (t * 2.51) + ' 251'); });
        });
      });
    }

    function show(i){
      i = ((i % total) + total) % total;
      current = i;
      panes.forEach(function(p, idx){ p.hidden = (idx !== i); });
      dots.forEach(function(d, idx){ d.classList.toggle('pofabout__value-modal-dot--active', idx === i); });
      animateCharts(panes[i]);
    }
    function open(i){ modal.hidden = false; document.body.style.overflow='hidden'; show(parseInt(i,10)||0); }
    function close(){ modal.hidden = true; document.body.style.overflow=''; }

    root.addEventListener('click', function(e){
      var o = e.target.closest('[data-pof-value-open]');
      if (o) { open(o.getAttribute('data-pof-value-open')); return; }
      if (e.target.closest('[data-pof-value-close]')) { close(); return; }
      if (e.target.closest('[data-pof-value-prev]')) { show(current - 1); return; }
      if (e.target.closest('[data-pof-value-next]')) { show(current + 1); return; }
      var dot = e.target.closest('[data-pof-value-goto]');
      if (dot) { show(parseInt(dot.getAttribute('data-pof-value-goto'), 10)); }
    });
    document.addEventListener('keydown', function(e){
      if (modal.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') show(current + 1);
      else if (e.key === 'ArrowLeft') show(current - 1);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pof-donate-form"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.pofdonate-form__type').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.pofdonate-form__type').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
    });
  });
  document.querySelectorAll('.pofdonate-form__amt').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.pofdonate-form__amt').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      const custom = document.querySelector('.pofdonate-form__custom');
      if (custom) custom.value = '';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pof-header"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var nav = document.getElementById('pof-nav');
    var toggle = document.getElementById('pof-nav-toggle');
    var close = document.getElementById('pof-nav-close');
    var mobile = document.getElementById('pof-nav-mobile');
    var scrollBtn = document.getElementById('pof-scroll-btn');

    if (toggle && mobile) {
      function setOpen(open) {
        mobile.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.body.style.overflow = open ? 'hidden' : '';
      }

      toggle.addEventListener('click', function(){
        setOpen(!mobile.classList.contains('is-open'));
      });

      if (close) {
        close.addEventListener('click', function(){
          setOpen(false);
        });
      }

      mobile.addEventListener('click', function(e){
        var link = e.target.closest('a');
        if (link) setOpen(false);
      });

      document.addEventListener('keydown', function(e){
        if (e.key === 'Escape' && mobile.classList.contains('is-open')) {
          setOpen(false);
        }
      });

      var mq = window.matchMedia('(min-width: 1024px)');
      if (mq.addEventListener) {
        mq.addEventListener('change', function(e){
          if (e.matches) setOpen(false);
        });
      }
    }

    if (nav) {
      var lastY = window.scrollY || 0;
      var ticking = false;

      function updateDesktopNav() {
        var currentY = window.scrollY || 0;

        // Runs at every width now. It used to bail out below 1024px, which is
        // what left the mobile header as a static pill with no scroll state.
        // Only exception: while the mobile menu overlay is open the bar stays
        // put, so the close control can't slide out from under the user.
        if (mobile && mobile.classList.contains('is-open')) {
          nav.classList.remove('is-hidden');
          lastY = currentY;
          ticking = false;
          return;
        }

        nav.classList.toggle('is-scrolled', currentY > 40);

        if (currentY <= 20) {
          nav.classList.remove('is-hidden');
        } else if (currentY > lastY && currentY > 110) {
          nav.classList.add('is-hidden');
        } else if (currentY < lastY) {
          nav.classList.remove('is-hidden');
        }

        lastY = currentY;
        ticking = false;
      }

      window.addEventListener('scroll', function(){
        if (!ticking) {
          window.requestAnimationFrame(updateDesktopNav);
          ticking = true;
        }
      }, { passive: true });

      updateDesktopNav();
    }

    if (scrollBtn) {
      scrollBtn.addEventListener('click', function(e){
        var href = scrollBtn.getAttribute('href');

        if (href && href.charAt(0) === '#') {
          var target = document.querySelector(href);

          if (target) {
            e.preventDefault();
            target.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pof-home-benefits"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var section = document.querySelector('[data-pof-benefits]');
    if (!section) return;
    var modal = section.querySelector('[data-pof-ben-modal]');
    if (!modal) return;
    var panes = modal.querySelectorAll('[data-pof-ben-pane]');
    function open(i){
      panes.forEach(function(p){ p.hidden = p.getAttribute('data-pof-ben-pane') !== String(i); });
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function close(){ modal.hidden = true; document.body.style.overflow = ''; }
    section.addEventListener('click', function(e){
      var opener = e.target.closest('[data-pof-benefit-open]');
      if (opener) { open(opener.getAttribute('data-pof-benefit-open')); return; }
      if (e.target.closest('[data-pof-ben-close]')) { close(); }
    });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !modal.hidden) close(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pof-home-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var hero = document.querySelector('[data-pof-hero]');
  if (!hero) return;

  var glow = hero.querySelector('[data-pof-glow]');
  if (glow) {
    hero.addEventListener('mousemove', function (e) {
      var r = hero.getBoundingClientRect();
      glow.style.left = (e.clientX - r.left - 192) + 'px';
      glow.style.top  = (e.clientY - r.top  - 192) + 'px';
    });
  }

  var bg = hero.querySelector('[data-pof-parallax]');
  if (bg) {
    var raf = null;

    function update() {
      raf = null;
      var y = window.scrollY;
      bg.style.transform = 'scale(' + (1 + y * 0.0002) + ') translateY(' + (y * 0.5) + 'px)';
    }

    window.addEventListener('scroll', function () {
      if (raf) return;
      raf = window.requestAnimationFrame(update);
    }, { passive: true });

    update();
  }

  var counters = hero.querySelectorAll('[data-pof-count-to]');

  function animate(el) {
    var target = parseFloat(el.getAttribute('data-pof-count-to') || '0');
    if (!target) return;

    var format = el.getAttribute('data-pof-count-format') || 'number';
    var baseText = el.textContent.trim();
    var suffixMatch = baseText.match(/([^\d,\.]+)$/);
    var suffix = suffixMatch ? suffixMatch[0] : '';
    var duration = 2200;
    var start = performance.now();

    function step(now) {
      var p = Math.min(1, (now - start) / duration);
      var eased = 1 - Math.pow(1 - p, 3);
      var v = Math.floor(target * eased);
      var out = format === 'comma' ? v.toLocaleString() : String(v);

      el.textContent = out + suffix;

      if (p < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          animate(e.target);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.3 });

    counters.forEach(function (c) {
      io.observe(c);
    });
  } else {
    counters.forEach(animate);
  }

  var scrollIndicator = hero.querySelector('[data-pof-scroll-indicator]');
  if (scrollIndicator) {
    var lastHidden = null;
    window.addEventListener('scroll', function () {
      var shouldHide = window.scrollY > 50;
      if (shouldHide !== lastHidden) {
        scrollIndicator.classList.toggle('is-hidden', shouldHide);
        lastHidden = shouldHide;
      }
    }, { passive: true });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pof-home-membership"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var root = document.querySelector('[data-pof-mem]');
    if (!root) return;
    var orb = root.querySelector('[data-pof-mem-orb]');
    var bg = root.querySelector('[data-pof-mem-parallax]');
    if (orb) {
      root.addEventListener('mousemove', function(e){
        var r = root.getBoundingClientRect();
        orb.style.left = (e.clientX - r.left - 350) + 'px';
        orb.style.top  = (e.clientY - r.top  - 350) + 'px';
      });
    }
    if (bg) {
      var raf = null;
      function update(){ raf = null; var y = window.scrollY; bg.style.transform = 'scale(1.1) translateY(' + (y * 0.08) + 'px)'; }
      window.addEventListener('scroll', function(){ if (raf) return; raf = window.requestAnimationFrame(update); }, { passive: true });
      update();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pof-home-principles"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var section = document.querySelector('[data-pof-principles]');
    if (!section) return;
    var modal = section.querySelector('[data-pof-principle-modal]');
    if (!modal) return;
    var panes = Array.prototype.slice.call(modal.querySelectorAll('[data-pof-principle-pane]'));
    var dots  = modal.querySelectorAll('[data-pof-principle-goto]');
    var total = panes.length;
    var current = 0;

    function animateBars(pane){
      // Reset all bars in this pane to 0, then animate to target on next frame
      var bars = pane.querySelectorAll('[data-pof-bar-target]');
      bars.forEach(function(b){
        var isHoriz = b.style.width !== '' || b.parentNode.classList.contains('pofhome__principle-modal-bar');
        if (isHoriz) { b.style.width = '0%'; } else { b.style.height = '0%'; }
      });
      requestAnimationFrame(function(){
        requestAnimationFrame(function(){
          bars.forEach(function(b){
            var target = b.getAttribute('data-pof-bar-target') + '%';
            var isHoriz = b.parentNode.classList.contains('pofhome__principle-modal-bar');
            if (isHoriz) { b.style.width = target; } else { b.style.height = target; }
          });
        });
      });
    }

    function show(i){
      i = ((i % total) + total) % total; // wrap
      current = i;
      panes.forEach(function(p, idx){ p.hidden = (idx !== i); });
      dots.forEach(function(d, idx){ d.classList.toggle('pofhome__principle-modal-dot--active', idx === i); });
      animateBars(panes[i]);
    }
    function open(i){
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      show(parseInt(i, 10) || 0);
    }
    function close(){
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    section.addEventListener('click', function(e){
      var opener = e.target.closest('[data-pof-principle-open]');
      if (opener) { open(opener.getAttribute('data-pof-principle-open')); return; }
      if (e.target.closest('[data-pof-principle-close]')) { close(); return; }
      if (e.target.closest('[data-pof-principle-prev]')) { show(current - 1); return; }
      if (e.target.closest('[data-pof-principle-next]')) { show(current + 1); return; }
      var dot = e.target.closest('[data-pof-principle-goto]');
      if (dot) { show(parseInt(dot.getAttribute('data-pof-principle-goto'), 10)); }
    });
    document.addEventListener('keydown', function(e){
      if (modal.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') show(current + 1);
      else if (e.key === 'ArrowLeft') show(current - 1);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pof-media-feature"] && !Shopify.designMode) return;
  try {
    
(function () {
  var scrollIndicator = document.querySelector('.pofmedia-feature [data-pof-scroll-indicator]');
  if (!scrollIndicator) return;
  var lastHidden = null;
  window.addEventListener('scroll', function () {
    var shouldHide = window.scrollY > 50;
    if (shouldHide !== lastHidden) {
      scrollIndicator.classList.toggle('is-hidden', shouldHide);
      lastHidden = shouldHide;
    }
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pof-media-videos"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-pof-video-card]').forEach(function (card) {
    var trigger = card.querySelector('[data-pof-video-play]');
    if (!trigger) return;
    trigger.addEventListener('click', function () {
      var videoEl = card.querySelector('[data-pof-video-el]');
      var iframeWrap = card.querySelector('[data-pof-video-iframe-wrap]');
      var youtubeId = card.getAttribute('data-pof-yt');
      card.classList.add('is-playing');
      if (videoEl) {
        try { videoEl.play(); } catch (e) {}
      } else if (iframeWrap && youtubeId) {
        if (!iframeWrap.querySelector('iframe')) {
          var iframe = document.createElement('iframe');
          iframe.setAttribute('src', 'https://www.youtube.com/embed/' + youtubeId + '?autoplay=1&rel=0');
          iframe.setAttribute('title', card.querySelector('.pofmedia-videos__title') ? card.querySelector('.pofmedia-videos__title').textContent : 'Video');
          iframe.setAttribute('frameborder', '0');
          iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
          iframe.setAttribute('allowfullscreen', 'allowfullscreen');
          iframeWrap.appendChild(iframe);
        }
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pof-membership-impact"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.querySelector('[data-pof-mimp]');
  if (!root) return;
  var activeTier = 0;
  var activeTab = 'tribes';
  var tiersEls = root.querySelectorAll('[data-pof-mimp-tier]');
  var tabEls = root.querySelectorAll('[data-pof-mimp-tab]');

  function getTier(idx){ return tiersEls[idx] || tiersEls[0]; }

  function parseBreakdown(str){
    if (!str) return [];
    try { return JSON.parse(str); }
    catch(e){
      var out = [];
      str.split(';').forEach(function(row){
        var parts = row.split('|');
        if (parts.length >= 3) out.push({ label: parts[0].trim(), amount: parseFloat(parts[1]), pct: parseFloat(parts[2]) });
      });
      return out;
    }
  }

  function render(){
    var t = getTier(activeTier);
    var amt = t.getAttribute('data-pof-amount');
    var trees = t.getAttribute('data-pof-trees');
    var acres = t.getAttribute('data-pof-acres');
    var co2 = t.getAttribute('data-pof-co2');
    var fam = t.getAttribute('data-pof-families');
    var famLabel = t.getAttribute('data-pof-families-label');
    var tribesTotal = t.getAttribute('data-pof-tribes-total');
    var foundationTotal = t.getAttribute('data-pof-foundation-total');
    var tribes = parseBreakdown(t.getAttribute('data-pof-tribes'));
    var foundation = parseBreakdown(t.getAttribute('data-pof-foundation'));

    root.querySelector('[data-pof-mimp-amt]').textContent = '$' + amt + '/month';
    root.querySelector('[data-pof-mimp-val="trees"]').textContent = trees;
    root.querySelector('[data-pof-mimp-val="acres"]').textContent = acres;
    root.querySelector('[data-pof-mimp-val="co2"]').textContent = co2;
    root.querySelector('[data-pof-mimp-val="families"]').textContent = fam;
    root.querySelector('[data-pof-mimp-val="families-unit"]').textContent = famLabel;
    root.querySelector('[data-pof-mimp-val="families-label"]').textContent = parseInt(fam, 10) > 0 ? 'directly sponsored' : 'Community support';

    var isTribes = activeTab === 'tribes';
    var total = isTribes ? tribesTotal : foundationTotal;
    var rows = isTribes ? tribes : foundation;
    var totalEl = root.querySelector('[data-pof-mimp-total]');
    var subEl = root.querySelector('[data-pof-mimp-sub]');
    var iconEl = root.querySelector('[data-pof-mimp-icon]');
    var footEl = root.querySelector('[data-pof-mimp-foot]');
    var tribesFoot = root.getAttribute('data-pof-tribes-foot') || '';
    var foundationFoot = root.getAttribute('data-pof-foundation-foot') || '';

    totalEl.textContent = '$' + (Math.round(parseFloat(total) * 100) / 100).toFixed(2);
    totalEl.setAttribute('data-pof-tab', activeTab);
    subEl.textContent = isTribes ? 'to Amazonian Communities' : 'to Foundation Programs';
    iconEl.setAttribute('data-pof-tab-bg', activeTab);
    iconEl.innerHTML = isTribes
      ? '<svg viewBox="0 0 24 24" fill="none" stroke="#036246" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" width="22" height="22"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>'
      : '<svg viewBox="0 0 24 24" fill="none" stroke="#2c1a0e" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" width="22" height="22"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>';
    footEl.textContent = isTribes ? tribesFoot : foundationFoot;

    var barsHost = root.querySelector('[data-pof-mimp-bars]');
    barsHost.innerHTML = '';
    rows.forEach(function(r){
      var wrap = document.createElement('div');
      wrap.className = isTribes ? '' : 'pofmimp--found';
      wrap.innerHTML =
        '<div class="pofmimp__bar-row ' + (isTribes ? '' : 'pofmimp--found') + '">' +
          '<span>' + r.label + '</span>' +
          '<span class="pofmimp__bar-amt">$' + (Math.round(r.amount * 100) / 100).toFixed(2) + '</span>' +
        '</div>' +
        '<div class="pofmimp__bar-track"><div class="pofmimp__bar-fill ' + (isTribes ? '' : 'pofmimp__bar-fill--foundation') + '" style="width:0%"></div></div>';
      barsHost.appendChild(wrap);
      var fill = wrap.querySelector('.pofmimp__bar-fill');
      requestAnimationFrame(function(){ fill.style.width = r.pct + '%'; });
    });
  }

  tiersEls.forEach(function(el){
    el.addEventListener('click', function(){
      tiersEls.forEach(function(e){ e.classList.remove('pofmimp__tier--active'); });
      el.classList.add('pofmimp__tier--active');
      activeTier = parseInt(el.getAttribute('data-pof-mimp-tier'), 10) || 0;
      render();
    });
  });
  tabEls.forEach(function(el){
    el.addEventListener('click', function(){
      tabEls.forEach(function(e){ e.classList.remove('pofmimp__tab--active'); });
      el.classList.add('pofmimp__tab--active');
      activeTab = el.getAttribute('data-pof-mimp-tab') || 'tribes';
      render();
    });
  });

  render();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pof-store-products"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.addEventListener('click', function(e){
      var btn = e.target.closest('[data-pof-cat]');
      if (!btn) return;
      var root = btn.closest('.pofstore-prod__inner');
      if (!root) return;
      var target = btn.getAttribute('data-pof-cat');
      root.querySelectorAll('[data-pof-cat]').forEach(function(b){ b.classList.remove('pofstore-prod__cat--active'); });
      btn.classList.add('pofstore-prod__cat--active');
      root.querySelectorAll('[data-pof-cat-id]').forEach(function(card){
        if (target === 'all' || card.getAttribute('data-pof-cat-id') === target) {
          card.removeAttribute('data-pof-hidden');
        } else {
          card.setAttribute('data-pof-hidden', 'true');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pof-yawanawa-pillars"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var root = document.querySelector('[data-pof-yawpillars]');
    if (!root) return;
    var modal = root.querySelector('[data-pof-pillar-modal]');
    if (!modal) return;
    var panes = Array.prototype.slice.call(modal.querySelectorAll('[data-pof-pillar-pane]'));
    var dots = modal.querySelectorAll('[data-pof-pillar-goto]');
    var total = panes.length;
    var current = 0;
    function show(i){
      i = ((i % total) + total) % total;
      current = i;
      panes.forEach(function(p, idx){ p.hidden = (idx !== i); });
      dots.forEach(function(d, idx){ d.classList.toggle('pofyaw__pillar-modal-dot--active', idx === i); });
    }
    function open(i){ modal.hidden = false; document.body.style.overflow='hidden'; show(parseInt(i,10)||0); }
    function close(){ modal.hidden = true; document.body.style.overflow=''; }
    root.addEventListener('click', function(e){
      var o = e.target.closest('[data-pof-pillar-open]');
      if (o) { open(o.getAttribute('data-pof-pillar-open')); return; }
      if (e.target.closest('[data-pof-pillar-close]')) { close(); return; }
      if (e.target.closest('[data-pof-pillar-prev]')) { show(current - 1); return; }
      if (e.target.closest('[data-pof-pillar-next]')) { show(current + 1); return; }
      var dot = e.target.closest('[data-pof-pillar-goto]');
      if (dot) { show(parseInt(dot.getAttribute('data-pof-pillar-goto'), 10)); }
    });
    document.addEventListener('keydown', function(e){
      if (modal.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') show(current + 1);
      else if (e.key === 'ArrowLeft') show(current - 1);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
